import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import MonthWisePlan from "../../components/MonthWisePlan/MonthWisePlan";

const MonthlyPlanningView = () => {
  const [monthPlanCount, setmonthPlanCount] = useState(0);

  const title = "Month Planning";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Monthly Plan",
            title: "Monthly Plan",
            count: monthPlanCount,
            countColor: 'blue',
            backgroundColor:'blue',
            component: MonthWisePlan,
            props: {
              handleCountChange: setmonthPlanCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default MonthlyPlanningView;
